import React, { forwardRef, useMemo } from "react";
import _ from "lodash";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, nameRegexValidator } from "utils/formUtils";
import message from "components/CustomMessage";
import BaseModalForm from "components/BaseModalForm";
import { duplicateNameValidator } from "utils/validatorUtil";

const AutomoxConfigForm = forwardRef( ({afterClose, configData = {}, ...props}, ref) => {
    const {configList, onUpdateConfigComponent} = props
    

    const submitData = async (data) => {
        const { id } = configData;
        if(id){
            await ToolsIntegrationsAPI.updateAutomoxConfigurations(id, {...data }).promise
        }else{
            await ToolsIntegrationsAPI.postAutomoxConfigurations({...data }).promise
        }
        onUpdateConfigComponent && onUpdateConfigComponent(true);
        message.success(`Successfully configured.`);
    }

    const baseModalProps = {
        okText: "Configure",
    }

    
    const fields = useMemo(() => [
        {
            name: "name",
            label: "Name",
            props: {
                autoFocus: true
            },
            colSpan: 24,
            required: true,
            rules: [
                nameRegexValidator,
                duplicateNameValidator({ list: configList }),
            ],
        },
        {
            name: "token",
            label: 'Token',
            help: 'Enter a valid token or Generate it',
            type: FieldTypes.PASSWORD,
            labelAlign: "left",
            colSpan: 24,
            required: true,
        },
        {
            name: "orgId",
            label: "Organization ID",
            type: FieldTypes.PASSWORD,
            labelAlign: "left",
            colSpan: 24,
            required: true,
        }        
    ], [configList]);

    return (
        <BaseModalForm    
            title= {_.isEmpty(configData) ? "Configure Automox" : "Edit Automox Configuration"}
            modalProps={baseModalProps}
            ref={ref}
            fields={fields}
            onOk={submitData}
            afterClose={afterClose}
            initialValues={configData}
        >
        </BaseModalForm>
    )
})

export default AutomoxConfigForm;